class PushStateObserver {
  constructor() {
    this.subscribers = [];
    this.originalPushState = window.history.pushState;
    window.history.pushState = this.pushState.bind(this);
  }
  pushState(state) {
    const history = window.history;
    if (typeof history.onpushstate == "function") {
      history.onpushstate({ state: state });
    }
    this.onPushState();
    return this.originalPushState.apply(history, arguments);
  }
  subscribe(callback) {
    if (typeof callback !== "function") {
      console.warn("PushStateObsever.subscribe() argument must be a function!");
      return;
    }
    this.subscribers.push(callback);
    console.log("New subscriber added to PushStateObserver");
  }
  onPushState() {
    this.subscribers.forEach(subscriber => subscriber());
    console.log("URL has changed!");
  }
}

export default PushStateObserver;



// WEBPACK FOOTER //
// ./src/js/helpers/pushStateObserver.js